import * as React from "react";
import { Auth, AuthContext } from "../../context/auth";
import { Translation, TranslationContext } from "../../context/translation";
import { useContextDataFetcher } from "../../context/fetcher";
import { authManager } from "../../global";

const initialAuth = new Auth();
const translation = new Translation();

const ContextData = ({ children }: { children: React.ReactNode }) => {
    const { ready } = useContextDataFetcher([], [initialAuth, translation]);
    const [auth, setAuth] = React.useState(initialAuth);

    // The roles belong to the access token, they have to be fetched again when a new token is obtained.
    React.useEffect(
        () =>
            authManager.rolesInvalidatedEvent.subscribe(() => {
                initialAuth.fetch().then(() => setAuth(initialAuth.clone()));
            }),
        [],
    );

    if (!ready) return null;

    return (
        <AuthContext.Provider value={auth}>
            <TranslationContext.Provider value={translation}>{children}</TranslationContext.Provider>
        </AuthContext.Provider>
    );
};

/**
 * The auth manager is started first: the roles need its access token, and the translations the locale of the profile
 * that comes with it.
 */
export default ({ children }: { children: React.ReactNode }) => {
    const [started, setStarted] = React.useState(false);

    React.useEffect(() => {
        authManager.start().then(() => setStarted(true));
    }, []);

    if (!started) return null;

    return <ContextData>{children}</ContextData>;
};
